import {GetApiMakeModelWithMakeApiResponse} from '@dms/api/shared';

export const makeModelWithMakeResponseMock: GetApiMakeModelWithMakeApiResponse = [
  {
    default_label: 'BMW',
    make: 'MAKE_BMW',
    vehicle_type: 'VEHICLETYPE_PASSENGER_CAR',
  },
  {
    default_label: '\u0160koda',
    make: 'MAKE_SKODA',
    vehicle_type: 'VEHICLETYPE_PASSENGER_CAR',
  },
  {
    default_label: 'Renault',
    make: 'MAKE_RENAULT',
    vehicle_type: 'VEHICLETYPE_PASSENGER_CAR',
  },
];
